// extracted by mini-css-extract-plugin
export default {"ConfirmEmail":"ConfirmEmail_ConfirmEmail__JFL2B"};